import React, { Component } from "react";
import { Link } from "react-router-dom";

import UI from "../../actions/ui-helper";
import StringUtil from "../../actions/string";

class ConsultaLancamentoResultado extends Component {

  componentWillUpdate() {
    UI.destroyTable(this.tableId);
  }

  componentDidUpdate() {
    UI.dataTable(this.tableId);
  }

  render() {
    if (this.props.resultado.length === 0) {
      return false;
    }
    this.tableId = StringUtil.uuid(5);

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="row">
            <div className="col-12 table-responsive">
              <table key={StringUtil.uuid(5)} id={this.tableId} className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Data</th>
                    <th>Descrição</th>
                    <th>Valor (R$)</th>
                    <th>Opções</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.resultado.map((lancamento, i) => {
                    return (
                      <tr key={lancamento.id}>
                        <td style={{width: "1%"}}>{lancamento.id}</td>
                        <td style={{width: "1%"}}>{lancamento.data}</td>
                        <td>{lancamento.descricao}</td>
                        <td style={{width: "1%"}}>{lancamento.valor.toFixed(2)}</td>
                        <td style={{width: "1%"}}>
                          <button className="btn btn-xs btn-light btn-option icon-btn" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="fa fa-cog"></i>
                          </button>
                          <div className="dropdown-menu">
                            <Link
                              to={"/financeiro/lancamento/cadastro/" + lancamento.id}
                              className="dropdown-item"><i className="fa fa-edit"></i>&nbsp;Editar</Link>
                            <span className="dropdown-item"><i className="fa fa-times"></i>&nbsp;Excluir</span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConsultaLancamentoResultado;
